import React from "react";
import { Alert, Box, Skeleton } from "@mui/material";

export function LoadingState(): React.JSX.Element {
  return (
    <Box sx={{ py: 2 }}>
      <Skeleton
        variant="rectangular"
        height={120}
        sx={{ mb: 2, borderRadius: 1 }}
      />
      <Skeleton
        variant="rectangular"
        height={120}
        sx={{ mb: 2, borderRadius: 1 }}
      />
      <Skeleton variant="rectangular" height={80} sx={{ borderRadius: 1 }} />
    </Box>
  );
}

export function ErrorState(): React.JSX.Element {
  return (
    <Alert severity="error" variant="outlined" sx={{ mb: 2 }}>
      Failed to load RFP data. Please try again later.
    </Alert>
  );
}
